import { cn } from "@gettactic/helpers";
import type { Setting } from "../constants";

interface SettingItemProps {
  setting: Setting;
  isActive: boolean;
  onSelect: () => void;
}

export function SettingItem({ setting, isActive, onSelect }: SettingItemProps) {
  return (
    <div
      onClick={onSelect}
      className={cn(
        "group flex cursor-pointer items-center gap-3 rounded-lg p-3 transition-colors",
        isActive ? "bg-neutral-100" : "hover:bg-neutral-50"
      )}
    >
      <div
        className={cn(
          "flex h-[22px] w-[22px] items-center justify-center rounded-full",
          setting.type === "action"
            ? "bg-neutral-1000 text-white"
            : "bg-neutral-100 text-neutral-600"
        )}
      >
        {setting.type === "action" ? (
          <svg
            className="h-3.5 w-3.5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 10V3L4 14h7v7l9-11h-7z"
            />
          </svg>
        ) : (
          <svg
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
        )}
      </div>

      <div className="flex-1">
        <h4
          className={cn(
            "font-inter text-[14px] text-neutral-1000",
            setting.type === "action" ? "font-normal" : "font-semibold"
          )}
        >
          {setting.name}
        </h4>
        {setting.type === "action" && (
          <p className="font-inter font-medium text-[12px] text-neutral-700" />
        )}
        {setting.type === "setting" && (
          <p className="font-inter font-medium text-[12px] text-neutral-700">
            {setting.description}
          </p>
        )}
      </div>

      {/* <div className="text-neutral-400 text-xs">
        <kbd className="rounded bg-neutral-100 px-1.5 py-0.5 font-mono text-[10px]">
          ↵
        </kbd>
      </div> */}
    </div>
  );
}
